import {Component, h} from '@stencil/core';

/**
 * @slot panel-section-title - Title of the panel-section
 * @slot panel-section-content - Main panel-section content
 **/

@Component({
    tag: 'joy-panel-section',
    styleUrl: 'panel-section.scss',
    shadow: true,
})
export class JoyPanelSection {
    render() {
        return (
            <div class="joy-panel-section">
                <slot name="panel-section-title" />
                <slot name="panel-section-content" />
            </div>
        );
    }
}
